import React, { Suspense, lazy, useState } from 'react'
import BaseContainer from '../BaseContainer'
import H1 from '../Headings/H1'
import { handleMarkerAutoSelect, resetMapPin } from "./leaflet-init";
import NetworkLocalOffice from './NetworkLocalOffice';
import { PushGADataLayer } from '../../utils/helpers';
const DiscoverNetwork = lazy(() => import(/* webpackChunkName: "discover-network" */ './DiscoverNetwork'));
const Map = lazy(() => import(/* webpackChunkName: "network-map" */ './Map'));

export default function NetworkMap(props) {
  const [mapData, setMapData] = useState(null)
  const [selectedStation, setSelectedStation] = useState(null)
  const [isNoResultActive, setIsNoResultActive] = useState(false)
  const [inputVal, setInputVal] = useState('')
   const [localOfficeInfo, setLocalOfficeInfo] = useState(null);

  const groundHandlingFeatureEnable = props.featureType === "networkbyairport" ? true :false;

  /* function to filter selected station */
  const handleSelectedStation = (e, allStations, isFromSearch = false, isGroundHandlingFeatureEnable = false) => {
    const alreadySelectedStation = groundHandlingFeatureEnable ? (selectedStation?.airport || '') : (selectedStation?.place || '')
    
    const stationName = e.target?._popup._content;
    setInputVal(stationName);
    const isSelected = { flag: false }
    // if selected station and again selected same station then opt out from the function
    if ((alreadySelectedStation && alreadySelectedStation.toLowerCase()) === (stationName && stationName.toLowerCase())) {
      return
    }

    allStations?.forEach(singleNetwork => {
      singleNetwork.stations.forEach(station => {
        const { place, airport } = station
        if (isGroundHandlingFeatureEnable && airport && stationName) {
          if (airport.toLowerCase() === stationName.toLowerCase()) {
            setSelectedStation(station);
            isSelected.flag = true
            if (isFromSearch) {
              PushGADataLayer('Contact Us', 'Location Searches', stationName);
              handleMarkerAutoSelect(station, isGroundHandlingFeatureEnable, isFromSearch)
            }
          }
        }
        if (!isGroundHandlingFeatureEnable && place && stationName) {
          if (place.toLowerCase() === stationName.toLowerCase()) {
            
            setLocalOfficeInfo({
              region:singleNetwork.region,
              country: singleNetwork.country,
              station:station
            })
            
            setSelectedStation(station);
            isSelected.flag = true
            if (isFromSearch) {
              PushGADataLayer('Contact Us', 'Location Searches', stationName);
              handleMarkerAutoSelect(station, isGroundHandlingFeatureEnable, isFromSearch)
            }
          }
        }
      });
    });

    /* reset incase of no match in set data */
    if (isSelected.flag === false) {
      resetSelectedStation()
      resetMapPin()
      setIsNoResultActive(true)
    } else {
      setIsNoResultActive(false)
    }

  }

  /* reset selected station */
  const resetSelectedStation = () => {
    setSelectedStation(null)
  }

  /* handleSearchSelect */
  const handleSearchSelect = (selected) => {
    const obj = {
      target: {
        _popup: {
          _content: selected[0]?.label
        }
      }
    }
    handleSelectedStation(obj, mapData?.data, true, groundHandlingFeatureEnable)
  }

  return (
    <BaseContainer className="mt-[40px] lg:mt-[80px] mb-[40px] lg:mb-[80px]">
      <div className="text-center grid lg:grid-cols-11">
        <div className="lg:col-start-3 lg:col-end-10">
          {groundHandlingFeatureEnable ?
            <>
            {mapData?.groundHandlingTitle && <H1 className="mb-4">{mapData?.groundHandlingTitle}</H1>}
            <div className="text-ek-grey-500 lg:text-ek-grey-600" dangerouslySetInnerHTML={{ __html: mapData?.groundHandlingDescription }}></div>
            </>  
            :
            (props.featureType !== "networkbylocaloffice"?
            <>
            {mapData?.heading && <H1 className="mb-4">{mapData?.heading}</H1>}
            <div className="text-ek-grey-500 lg:text-ek-grey-600" dangerouslySetInnerHTML={{ __html: mapData?.desc }}></div>
            </> :
            <>
            {mapData?.localOffice?.title && <H1 className="!leading-[48px] mb-4">{mapData.localOffice.title}</H1>}
            {mapData?.localOffice?.desc && <div className="text-ek-grey-500 lg:text-ek-grey-600" dangerouslySetInnerHTML={{ __html: mapData.localOffice.desc }}></div>}
            </>)
          }
        </div>
      </div>

      <Suspense fallback={<div>Loading...</div>}>
        <Map {...props}
          setMapData={setMapData}
          handleSelectedStation={handleSelectedStation}
          resetSelectedStation={resetSelectedStation}
        />
        {mapData &&
        <>
        {props.featureType !== "networkbylocaloffice"?
        <DiscoverNetwork
          {...props}
          mapData={mapData}
          selectedStation={selectedStation}
          handleSearchSelect={handleSearchSelect}
          resetSelectedStation={resetSelectedStation}
          isNoResultActive={isNoResultActive}
          setIsNoResultActive={setIsNoResultActive}
          inputVal={inputVal}
          setInputVal={setInputVal}
        ></DiscoverNetwork>
      :<NetworkLocalOffice
        localOfficeInfo={localOfficeInfo} 
        selectedStationInfo={selectedStation}
        mapData={mapData} />
      }
      </>}
      </Suspense>
    </BaseContainer>

  )
}
